"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _config = require("webmotors-react-pj/config");
var _img = _interopRequireDefault(require("webmotors-react-pj/img"));
const Link = _styledComponents.default.a.withConfig({
  displayName: "Link",
  componentId: "sc-shpzpq-0"
})(["padding:8px 0;opacity:0.7;transition:opacity 0.3s;display:block;line-height:1em;font-family:Figtree;&:hover{opacity:1;}"]);
const Img = (0, _styledComponents.default)(_img.default).withConfig({
  displayName: "Img",
  componentId: "sc-shpzpq-1"
})(["width:22px;height:22px;margin-right:12px;vertical-align:middle;transform:translateY(-2px);"]);
var _default = _ref => {
  let {
    children,
    icon,
    href,
    target
  } = _ref;
  return _react.default.createElement("li", null, _react.default.createElement(Link, {
    target: target,
    rel: target ? 'noopener noreferrer' : '',
    href: href
  }, _react.default.createElement(Img, {
    alt: "",
    "aria-hidden": "true",
    src: "".concat(_config.UrlCockpit, "/assets/img/icons/").concat(icon)
  }), children));
};
exports.default = _default;